import { isObject } from 'lodash';
/**
   * @ngdoc directive
   * @name adjust.directive:required
   * @restrict A
   * @priority 100
   *
   * @description
   * Override built-in required directive in order to reject values which have only spaces
   * This is due to ng-trim="false" usage on some inputs
   *
   */
function required() {
  'ngInject';
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, elm, attr, ctrl) {

      attr.required = true;

      ctrl.$validators.required = function(modelValue, viewValue) {

        if (isObject(viewValue)) {
          return true;
        }

        var trimmedValue = viewValue ? viewValue.trim() : '';

        return !attr.required || !ctrl.$isEmpty(trimmedValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });

    }
  };
}
export { required };
